import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface PayoffBarrierLevelFormFieldProps {
  label?: string
}

export const PayoffBarrierLevelFormField: React.FC<PayoffBarrierLevelFormFieldProps> = ({
  label,
}) => {
  const { control, register } = useFormContext<{ payoff_barrier_level: number }>()

  return (
    <FormField
      control={control}
      name="payoff_barrier_level"
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center">
              <FormLabel>{label ?? 'Payoff Barrier Level'}</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput {...register('payoff_barrier_level')} />
          </FormItem>
        )
      }}
    />
  )
}
